import { listMyActivities } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";

export const GetCurrentUserActivities = {
  data() {
    return {
      GetActivitiesList: [],
      overlay: false,
      user_type: "",
      ViolationsList: [],
    };
  },
  methods: {
    async Get_CureentUser_Activities_Method() {
      try {
        this.loading = true;
        this.overlay = true;
        let result = await API.graphql(
          graphqlOperation(listMyActivities, {
            input: {
              police_id: this.$store.getters.get_current_user_details.user_id,
            },
          })
        );

        console.log("resultresult", result);
        this.GetActivitiesList = JSON.parse(
          result.data.listMyActivities
        ).data.items;

        for (let i = 0; i < this.GetActivitiesList.length; i++) {
          let activityRecord = this.GetActivitiesList[i];

          // Convert start_location coordinates to address
          if (
            activityRecord.start_location &&
            activityRecord.start_location.length === 2
          ) {
            const [startLat, startLng] = activityRecord.start_location;
            activityRecord.start_location =
              await this.convertCoordinatesToAddress(startLat, startLng);
          }

          // Convert end_location coordinates to address
          if (
            activityRecord.end_location &&
            activityRecord.end_location.length === 2
          ) {
            const [endLat, endLng] = activityRecord.end_location;
            activityRecord.end_location =
              await this.convertCoordinatesToAddress(endLat, endLng);
          }
        }
        console.log(
          "resultrethis.GetActivitiesListsult",
          this.GetActivitiesList
        );
        this.loading = false;
        this.overlay = false;
      } catch (error) {
        console.log("Check error", error);
        this.loading = false;
        this.overlay = false;
        return "ERROR";
      }
    },

    convertCoordinatesToAddress(lat, lng) {
      return new Promise((resolve) => {
        const xhttp = new XMLHttpRequest();
        xhttp.open(
          "GET",
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBrftCAqKGbs4qrzM1JL8_Sb8Kl7Dk5CLQ`,
          true
        );
        xhttp.send();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            const response = JSON.parse(this.responseText);
            if (response.results && response.results[0]) {
              resolve(response.results[0].formatted_address);
            } else {
              resolve("Address not found");
            }
          }
        };
      });
    },
  },
};
